export default __webpack_public_path__ + "static/sunnybenches-a63ace0dc59dd921ed9388867b8daf7c.png";